import {makeStyles} from "@material-ui/core";
import { Colors } from "./globalColors";

export const useGlobalText = makeStyles({

    smallText:{
        fontSize:'18px',
        fontWeight:'600',
        color:Colors.TextSecondary,
    },
    title:{
        fontSize:'24px',
        fontWeight:'bold',
        color:Colors.TextSecondary,
    },

    smallSwitchText:{
        fontSize: '14px',
        color: Colors.TextSecondary,
        marginRight: '8px',
        whiteSpace:'nowrap',
    },

    switchText:{
        fontSize: '14px',
        color: Colors.TextSecondary,
        marginRight: '8px',
    },

    nameEllipsis:{
        overflow:'hidden',
        whiteSpace:'nowrap',
        textOverflow:'ellipsis',
        width:'110px',
        // textTransform:'uppercase',
        "@media (min-width: 1919px)": {
            width:'150px',
        },
    },

    nameEllipsisBig:{
        overflow:'hidden',
        whiteSpace:'nowrap',
        textOverflow:'ellipsis',
        width:'110px',
        "@media (min-width: 1919px)": {
            width:'150px',
        },
    },

    tableNameEllipsis:{
        width:'auto',
        maxWidth:'200px',
        overflow:'hidden',
        whiteSpace:'nowrap',
        textOverflow:'ellipsis',
        textTransform:'uppercase',
        color: `${Colors.TextSecondary}!important`,
        fontWeight:'bold',
        marginLeft:'4px',
        fontSize:'16px',
        "@media (min-width: 1919px)": {
            maxWidth:'250px',
        },
    },

    addressEllipsis:{
        overflow:'hidden',
        whiteSpace:'nowrap',
        textOverflow:'ellipsis',
        width:'200px',
        "@media (min-width: 1919px)": {
            width:'250px',
        },
    } ,
    desc:{
        overflow:'hidden',
        whiteSpace:'nowrap',
        textOverflow:'ellipsis',
        width:'200px',
        "@media (min-width: 1919px)": {
            width:'250px',
        },
    } ,
    id:{
        overflow:'hidden',
        whiteSpace:'nowrap',
        textOverflow:'ellipsis',
        width:'80px',
        "@media (min-width: 1919px)": {
            width:'80px',
        },
    } ,

    emailEllipsis:{
        overflow:'hidden',
        whiteSpace:'nowrap',
        textOverflow:'ellipsis',
        width:'150px',
        "@media (min-width: 1919px)": {
            width:'200px',
        },
    },

    drag: {
        fontSize: '24px',
        fontWeight: '600',
        color: Colors.TextPrimary,
    },

    upload: {
        fontSize: '24px',
        fontWeight: '600',
        color: `${Colors.ThemeBlue}!important`,
        marginLeft:'8px',
    },

    resendInvite:{
        display:'flex',
        justifyContent:'flex-end',

        '& button':{
            width:'150px',
        }
    }
})
